import { Component, OnInit } from '@angular/core';
import { AppComponent } from './../app.component';
import  {Chart} from 'node_modules/chart.js';

import { Router } from '@angular/router';

import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  safeURL: any;
 
  constructor(private router: Router) {
 
  

   }







  ngOnInit(): void {
    this.getChart();
    this.getChart2();
    this.getChart3();
    this.getChart4();
  }
  

   
  async getChart(){

    // tslint:disable-next-line:prefer-const
    let ctx = document.getElementById('myChart');
    console.log('dgfhdfgkjsd'+ctx)
    // tslint:disable-next-line:prefer-const
    let myChart = new Chart(ctx, {
      type: 'radar',
      data: {
          labels: ['Virage et freinage', 'Virage et accélération', 'Accélération' , 'Freinage', 'Virage', 'Excés de vitesse', 'Franchissement de ligne'],
          datasets: [{
              label: 'STG DEMO',
              fill: false,
              data: [15 , 80, 20 , 26, 78 , 38 , 50 ],
              backgroundColor: [
                'rgb(245, 89, 82 ,0)',


              ],
              borderColor: [
                'rgb(245, 89, 82 ,1)',


              ],
              borderWidth: 1,
              pointStyle: 'circle',
              pointRadius: '5',
              pointBackgroundColor: 'rgb(245, 89, 82 ,1)',
              pointBorderColor: 'rgb(245, 89, 82 ,1)'
          },


          {
            label: 'V-1235',
            fill: true,
            data: [20, 90, 38, 56 ,  86 ,  48 , 53],
            backgroundColor: [
                'rgb(210, 34, 84,0)',


            ],
            borderColor: [
                'rgb(210, 34, 84 ,1)',

            ],
            borderWidth: 1,
            pointStyle: 'circle',
            pointRadius: '5',
            pointBackgroundColor: 'rgb(210, 34, 84,1)',
            pointBorderColor: 'rgb(210, 34, 84 ,1)'
        }
        ]
      },
      options: {
        tooltips: {
          custom(tooltip) {
            if (!tooltip) { return; }
            // disable displaying the color box;
            tooltip.displayColors = false;
          },
          callbacks: {
            title(tooltipItem, data) {
              return data.labels[tooltipItem[0].index];
            }, label(tooltipItem, data) {
              return data.datasets[tooltipItem.datasetIndex].label + ':' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + '€';

            },


          },

          yAlign: 'bottom',
          backgroundColor: 'rgb(50, 61, 65)',

      },
        layout: {
          padding: {
              left: 10,
              right: 0,
              top: 0,
              bottom: 0
          },

      },
        legend: {
          display: true,
          position: 'left',
          align: 'start',

          labels: {

            usePointStyle: true,


          }
      },
          scales: {

            xAxes: [{
              ticks: {
                display: false,
                padding: 30
              },
              gridLines: {
                display: false,
                drawOnChartArea: false,
                drawTicks: false,

              }
            }],
              yAxes: [{
                  ticks: {
                      beginAtZero: true,
                      display: false,


                  },
                  gridLines: {
                    display: false,
                    drawOnChartArea: false,
                    drawTicks: false
                  }
              }]
          }
      }
  });

   }




   async getChart2(){

    // tslint:disable-next-line:prefer-const
    let ctx = document.getElementById('myChart2');
    console.log('dgfhdfgkjsd'+ctx)
    // tslint:disable-next-line:prefer-const
    let myChart = new Chart(ctx, {
      type: 'polarArea',
      data: {
          labels: ['Virage et freinage', 'Virage et accélération', 'Accélération' , 'Freinage', 'Virage', 'Excés de vitesse', 'Franchissement de ligne'],
          datasets: [{
              label: 'STG DEMO',
              fill: false,
              data: [15 , 80, 20 , 26, 78 , 38 , 50 ],
              backgroundColor: [
                'rgb(245, 89, 82 ,0)',


              ],
              borderColor: [
                'rgb(245, 89, 82 ,1)',


              ],
              borderWidth: 1,
              pointStyle: 'circle',
              pointRadius: '5',
              pointBackgroundColor: 'rgb(245, 89, 82 ,1)',
              pointBorderColor: 'rgb(245, 89, 82 ,1)'
          },


          {
            label: 'V-1235',
            fill: true,
            data: [20, 90, 38, 56 ,  86 ,  48 , 53],
            backgroundColor: [
                'rgb(210, 34, 84,0)',


            ],
            borderColor: [
                'rgb(210, 34, 84 ,1)',

            ],
            borderWidth: 1,
            pointStyle: 'circle',
            pointRadius: '5',
            pointBackgroundColor: 'rgb(210, 34, 84,1)',
            pointBorderColor: 'rgb(210, 34, 84 ,1)'
        }
        ]
      },
      options: {
        tooltips: {
          custom(tooltip) {
            if (!tooltip) { return; }
            // disable displaying the color box;
            tooltip.displayColors = false;
          },
          callbacks: {
            title(tooltipItem, data) {
              return data.labels[tooltipItem[0].index];
            }, label(tooltipItem, data) {
              return data.datasets[tooltipItem.datasetIndex].label + ':' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + '€';

            },


          },

          yAlign: 'bottom',
          backgroundColor: 'rgb(50, 61, 65)',

      },
        layout: {
          padding: {
              left: 10,
              right: 0,
              top: 0,
              bottom: 0
          },

      },
        legend: {
          display: true,
          position: 'left',
          align: 'start',

          labels: {

            usePointStyle: true,


          }
      },
          scales: {

            xAxes: [{
              ticks: {
                display: false,
                padding: 30
              },
              gridLines: {
                display: false,
                drawOnChartArea: false,
                drawTicks: false,

              }
            }],
              yAxes: [{
                  ticks: {
                      beginAtZero: true,
                      display: false,


                  },
                  gridLines: {
                    display: false,
                    drawOnChartArea: false,
                    drawTicks: false
                  }
              }]
          }
      }
  });

   }


   async getChart3(){

    // tslint:disable-next-line:prefer-const
    let ctx = document.getElementById('myChart3');
    console.log('dgfhdfgkjsd'+ctx)
    // tslint:disable-next-line:prefer-const
    let myChart = new Chart(ctx, {
      type: 'line',
      data: {
          labels: ['Virage et freinage', 'Virage et accélération', 'Accélération' , 'Freinage', 'Virage', 'Excés de vitesse', 'Franchissement de ligne'],
          datasets: [{
              label: 'STG DEMO',
              fill: false,
              data: [15 , 80, 20 , 26, 78 , 38 , 50 ],
              backgroundColor: [
                'rgb(245, 89, 82 ,0)',


              ],
              borderColor: [
                'rgb(245, 89, 82 ,1)',


              ],
              borderWidth: 1,
              pointStyle: 'circle',
              pointRadius: '5',
              pointBackgroundColor: 'rgb(245, 89, 82 ,1)',
              pointBorderColor: 'rgb(245, 89, 82 ,1)'
          },


          {
            label: 'V-1235',
            fill: true,
            data: [20, 90, 38, 56 ,  86 ,  48 , 53],
            backgroundColor: [
                'rgb(210, 34, 84,0)',


            ],
            borderColor: [
                'rgb(210, 34, 84 ,1)',

            ],
            borderWidth: 1,
            pointStyle: 'circle',
            pointRadius: '5',
            pointBackgroundColor: 'rgb(210, 34, 84,1)',
            pointBorderColor: 'rgb(210, 34, 84 ,1)'
        }
        ]
      },
      options: {
        tooltips: {
          custom(tooltip) {
            if (!tooltip) { return; }
            // disable displaying the color box;
            tooltip.displayColors = false;
          },
          callbacks: {
            title(tooltipItem, data) {
              return data.labels[tooltipItem[0].index];
            }, label(tooltipItem, data) {
              return data.datasets[tooltipItem.datasetIndex].label + ':' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + '€';

            },


          },

          yAlign: 'bottom',
          backgroundColor: 'rgb(50, 61, 65)',

      },
        layout: {
          padding: {
              left: 10,
              right: 0,
              top: 0,
              bottom: 0
          },

      },
        legend: {
          display: true,
          position: 'left',
          align: 'start',

          labels: {

            usePointStyle: true,


          }
      },
          scales: {

            xAxes: [{
              ticks: {
                display: false,
                padding: 30
              },
              gridLines: {
                display: false,
                drawOnChartArea: false,
                drawTicks: false,

              }
            }],
              yAxes: [{
                  ticks: {
                      beginAtZero: true,
                      display: false,


                  },
                  gridLines: {
                    display: false,
                    drawOnChartArea: false,
                    drawTicks: false
                  }
              }]
          }
      }
  });

   }



   async getChart4(){

    // tslint:disable-next-line:prefer-const
    let ctx = document.getElementById('myChart4');
    console.log('dgfhdfgkjsd'+ctx)
    // tslint:disable-next-line:prefer-const
    let myChart = new Chart(ctx, {
      type: 'pie',
      data: {
          labels: ['Virage et freinage', 'Virage et accélération', 'Accélération' , 'Freinage', 'Virage', 'Excés de vitesse', 'Franchissement de ligne'],
          datasets: [{
              label: 'STG DEMO',
              fill: false,
              data: [15 , 80, 20 , 26, 78 , 38 , 50 ],
              backgroundColor: [
                'rgb(245, 89, 82 ,0)',
                'rgba(213, 60, 59, 1)'


              ],
              borderColor: [
                'rgb(245, 89, 82 ,1)',


              ],
              borderWidth: 1,
              pointStyle: 'circle',
              pointRadius: '5',
              pointBackgroundColor: 'rgb(245, 89, 82 ,1)',
              pointBorderColor: 'rgb(245, 89, 82 ,1)'
          },


          {
            label: 'V-1235',
            fill: true,
            data: [20, 90, 38, 56 ,  86 ,  48 , 53],
            backgroundColor: [
                'rgb(210, 34, 84,0)',


            ],
            borderColor: [
                'rgb(210, 34, 84 ,1)',

            ],
            borderWidth: 1,
            pointStyle: 'circle',
            pointRadius: '5',
            pointBackgroundColor: 'rgb(210, 34, 84,1)',
            pointBorderColor: 'rgb(210, 34, 84 ,1)'
        }
        ]
      },
      options: {
        tooltips: {
          custom(tooltip) {
            if (!tooltip) { return; }
            // disable displaying the color box;
            tooltip.displayColors = false;
          },
          callbacks: {
            title(tooltipItem, data) {
              return data.labels[tooltipItem[0].index];
            }, label(tooltipItem, data) {
              return data.datasets[tooltipItem.datasetIndex].label + ':' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + '€';

            },


          },

          yAlign: 'bottom',
          backgroundColor: 'rgb(50, 61, 65)',

      },
        layout: {
          padding: {
              left: 10,
              right: 0,
              top: 0,
              bottom: 0
          },

      },
        legend: {
          display: true,
          position: 'left',
          align: 'start',

          labels: {

            usePointStyle: true,


          }
      },
          scales: {

            xAxes: [{
              ticks: {
                display: false,
                padding: 30
              },
              gridLines: {
                display: false,
                drawOnChartArea: false,
                drawTicks: false,

              }
            }],
              yAxes: [{
                  ticks: {
                      beginAtZero: true,
                      display: false,


                  },
                  gridLines: {
                    display: false,
                    drawOnChartArea: false,
                    drawTicks: false
                  }
              }]
          }
      }
  });

   }
}
